module.exports = __webpack_public_path__ + "img/flame-icon.34b6ad9c.svg";